import config from "config";
import { PATH_NAME_BASE } from "helpers/validators.js";

const postRequest = async (
  controller,
  functionName,
  parameters,
  recaptcha,
  contentType,
  authKey,
  disableStringify,
  method,
  culture,
  apiOrBase,
  signal
) => {
  const url = `${apiOrBase ? config.api.src : config.env.src}/${controller}${
    functionName ? "/" + functionName : ""
  }`;

  const headers = new Headers();
  headers.append("Authorization", authKey ? "Bearer " + authKey : false);
  headers.append("Content-Type", contentType);
  headers.append("Accept", "*/*");
  headers.append("X-Culture", culture);
  headers.append("X-Origin", window.location.origin);

  // Create custom referrer with hostname + language + current page
  const hostname = window.location.hostname; // e.g., jumbomail.me
  const pathname = window.location.pathname; // e.g., /en/home/section/subsection

  // Extract only first two path segments (language and pagename)
  const pathSegments = pathname.split("/").filter((segment) => segment); // Remove empty segments
  const language = pathSegments[0] || ""; // First segment (language)
  const pagename = pathSegments[1] || ""; // Second segment (pagename)

  // Construct referrer with only hostname, language and pagename
  const customReferrer = `${hostname}/${language}/${pagename}`;
  headers.append("X-Referer", customReferrer);

  const response = await fetch(url, {
    method: method.toUpperCase(),
    headers: headers,
    body: disableStringify ? parameters : JSON.stringify(parameters),
    signal: typeof signal === "string" ? undefined : signal,
  });

  // should add more cases as needed
  switch (response.status) {
    case 200:
      const res = await response.json();
      return { status: "success", data: res };
    case 204:
      return { status: "success" };
    case 409:
      // Need to get text key from response to display error message
      if (functionName === "ClientCheckoutSubmitReact") {
        const errorCode = await response.json();
        return { status: "error", data: errorCode?.Code };
      }

      let text = await response.text();
      if (text === "CaptchaRequired")
        if (recaptcha && recaptcha.set && recaptcha.form) {
          //first, init recaptcha
          recaptcha.set(true, recaptcha.form);
          //than, set it to be displayed in the form
          recaptcha.set(true, recaptcha.form);
          text = "recaptcha-required";
        }
      return { status: "error", data: text };

    case 429:
      // doing redirect to /user-blocked page, if its not already there
      if (!window.location.pathname.includes("/user-blocked")) {
        const pathBase = window.location.pathname.match(PATH_NAME_BASE);
        if (pathBase) {
          window.location.pathname = pathBase[0] + "user-blocked";
        }
      }

    default:
      return { status: "error", data: await response.text() };
  }
};

export default postRequest;
